import React from 'react';

import ToggleLeftSideButton from './ToggleLeftSideButton'
import StockSummary from './StockSummary'
import ChartOptionsController from './ChartOptionsController'
import AdditionalSeriesController from './AdditionalSeriesController'
import useStock from "../../hooks/useStock";
import iconClosed from '@shared/assets/images/icon-closed.png'
import {useSetIsMiniPlayerEnabled} from "../../../live/contexts/miniPlayer";

export default function Top() {
  const stock = useStock()
  const handleMiniPlayer = useSetIsMiniPlayerEnabled()

  const handleClickCloseChart = () => {
    handleMiniPlayer.inactive()
  }

  return (
    <>
      <div className="info_wrap">
        <div className="info">
          <StockSummary/>
        </div>
        <div className="chartDate date">
          <div className="tools-container">
            <ChartOptionsController/>
            <AdditionalSeriesController/>
          </div>
          <div>
            {stock?.contents?.shortCode && (
              <a
                href={
                  'https://www.wowtv.co.kr/Finance/DomesticStock/DomesticStockDetail?menuSeq=464&searchStr=' +
                  stock.contents.shortCode.slice(1)
                }
                target="_blank"
                rel="noopener noreferrer"
                className="btn btn_info"
              >
                종목정보
              </a>
            )}
          </div>
        </div>
      </div>
      <div className="graph_wrap">
        <ul>
          <li className="type01">
            <p>단기</p>
            <div>
              <span style={{width: '30%'}}></span>
            </div>
          </li>
          <li className="type02">
            <p>중기</p>
            <div>
              <span style={{width: '50%'}}></span>
            </div>
          </li>
          <li className="type03">
            <p>장기</p>
            <div>
              <span style={{width: '70%'}}></span>
            </div>
          </li>
        </ul>
      </div>
      <div className='closeBtnWrapper'>
        <div
          onClick={handleClickCloseChart}
          className ='closeBtn'>
          <img src={iconClosed} width={18}/>
        </div>
      </div>
    </>
  )
}

